var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rich-cell',{on:{"click":_vm.showPicker}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._v(_vm._s(_vm.checkStatus))]),_c('i',{staticClass:"richic-arrow"})])}
var staticRenderFns = []

export { render, staticRenderFns }